<div *ngIf="tabItem" class="hd--header-tap mat-typography">
    <div (click)="onTabClick()" fxLayout="row" class="hd--header-tap-wrapper" fxLayoutAlign="center center" [ngClass]="{'active' : tabItem.isActive}">
        <a class="hd--header-tap-text">{{tabItem.text}}</a>
        <mat-icon (click)="onCancelClick()">cancel</mat-icon>
    </div>
</div>
